import { render, staticRenderFns } from "./ChangeUnitPhoneDetails.vue?vue&type=template&id=70d251e8&"
import script from "./ChangeUnitPhoneDetails.vue?vue&type=script&lang=js&"
export * from "./ChangeUnitPhoneDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports